import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = { class: "flex flex-col gap-2" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row items-center gap-2"
}
const _hoisted_4 = { class: "text-xs font-bold" }
const _hoisted_5 = {
  key: 1,
  class: "mt-6 flex max-h-96 flex-col gap-6 overflow-y-auto"
}
const _hoisted_6 = { class: "grid grid-cols-5 gap-2" }
const _hoisted_7 = { class: "text-muted-foreground" }

import { Checkbox } from '@/components/ui/checkbox';
    import { CheckboxGroupRoot, useFilter } from 'reka-ui';
    import { Label } from '@/components/ui/label';
    import { PermissionOption } from '@/types';
    import { ref, computed } from 'vue';
    import { Separator } from '@/components/ui/separator';
    import { usePermissionOptions } from '@/composables/usePermissionOptions';
    import Loading from '@/components/Loading.vue';
    import SearchInput from '@/components/SearchInput.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RolePermissionsForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    const { permissionsOptions, isPlaceholderDataPermissionsOptions } = usePermissionOptions();

    const props = __props;

    const searchTerm = ref('');
    const { contains } = useFilter({ sensitivity: 'base' });

    const filteredPermissions = computed(() =>
        permissionsOptions.value.filter((option: PermissionOption) =>
            contains(option.label, searchTerm.value),
        ),
    );

    const allSelected = computed({
        get: () => {
            const totalOptions = permissionsOptions.value.reduce(
                (total: number, permission: PermissionOption) => total + permission.options.length,
                0,
            );
            return props.form.permission_ids.length === totalOptions;
        },
        set: () => toggleAll(),
    });

    const toggleAll = () => {
        if (allSelected.value) {
            props.form.permission_ids = [];
        } else {
            props.form.permission_ids = permissionsOptions.value.flatMap(
                (permission: PermissionOption) => permission.options.map((option) => option.value),
            );
        }
    };

    const isGroupSelected = (permission: PermissionOption) => {
        return permission.options.every((option) =>
            props.form.permission_ids.includes(option.value),
        );
    };

    const toggleGroup = (permission: PermissionOption) => {
        if (isGroupSelected(permission)) {
            props.form.permission_ids = props.form.permission_ids.filter(
                (id: number) => !permission.options.some((option) => option.value === id),
            );
        } else {
            props.form.permission_ids = [
                ...props.form.permission_ids,
                ...permission.options.map((option) => option.value),
            ];
        }
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Label), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('roles.select.permissions.placeholder')), 1)
        ]),
        _: 1
      }),
      _createVNode(SearchInput, {
        placeholder: _ctx.$t('roles.select.permissions.search_options.default'),
        modelValue: searchTerm.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
        disabled: _unref(isPlaceholderDataPermissionsOptions)
      }, null, 8, ["placeholder", "modelValue", "disabled"])
    ]),
    (!_unref(isPlaceholderDataPermissionsOptions))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(Label), { class: "flex flex-row items-center gap-2 font-normal" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Checkbox), {
                modelValue: allSelected.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((allSelected).value = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("span", null, _toDisplayString(allSelected.value
                        ? _ctx.$t('roles.select.texts.unselectAll')
                        : _ctx.$t('roles.select.texts.selectAll')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Separator), {
            orientation: "vertical",
            class: "h-2.5!"
          }),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.form.permission_ids.length) + " " + _toDisplayString(_ctx.$t('roles.select.texts.selectedOptions')), 1)
        ]))
      : _createCommentVNode("", true),
    (!_unref(isPlaceholderDataPermissionsOptions))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPermissions.value, (permission) => {
            return (_openBlock(), _createElementBlock("div", null, [
              _createVNode(_unref(Label), { class: "text-secondary border-secondary mb-2 flex flex-row items-center gap-2 border-b pb-2 font-normal" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(permission.label), 1)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(Label), { class: "flex flex-row items-center gap-2 font-normal" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Checkbox), {
                      "model-value": isGroupSelected(permission),
                      "onUpdate:modelValue": () => toggleGroup(permission)
                    }, null, 8, ["model-value", "onUpdate:modelValue"]),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(isGroupSelected(permission)
                                ? _ctx.$t('roles.select.texts.unselectAll')
                                : _ctx.$t('roles.select.texts.selectAll')), 1)
                  ]),
                  _: 2
                }, 1024),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permission.options, (option) => {
                  return (_openBlock(), _createBlock(_unref(CheckboxGroupRoot), {
                    modelValue: _ctx.form.permission_ids,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.permission_ids) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Label), { class: "flex flex-row items-center gap-2 font-normal" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Checkbox), {
                            value: option.value
                          }, null, 8, ["value"]),
                          _createElementVNode("span", null, _toDisplayString(option.label), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["modelValue"]))
                }), 256))
              ])
            ]))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    (_unref(isPlaceholderDataPermissionsOptions))
      ? (_openBlock(), _createBlock(Loading, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}
}

})